export default "__VITE_ASSET__DDIkXv2w__"